import {
  ChangeDetectionStrategy,
  Component,
  contentChild,
  input,
  TemplateRef,
} from '@angular/core';
import { Tooltip } from 'primeng/tooltip';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'ct-extraction-warning',
  imports: [Tooltip, NgTemplateOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div
      class="bg-warning-light text-theme-gray-900 flex items-center gap-3 rounded-xl p-2 text-xs shadow"
      [pTooltip]="tooltipTemplate()"
      tooltipPosition="bottom">
      @if (contentTemplate()) {
        <ng-container [ngTemplateOutlet]="contentTemplate()" />
      } @else {
        <span class="!text-warning material-icons">warning</span>
        <span>{{ text() }}</span>
      }
    </div>
  `,
  styles: `
    ::ng-deep {
      .p-tooltip {
        max-width: fit-content;
      }
    }
  `,
})
export class WarningComponent {
  readonly tooltipTemplate = contentChild<TemplateRef<HTMLElement>>('tooltip');
  readonly contentTemplate = contentChild<TemplateRef<HTMLElement>>('content');

  readonly text = input<string>('');
}
